import { Divider, Grid } from '@mui/material'
import CardRadioForm from 'global/components/CardRadioForm'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext } from 'react-hook-form'

export function TipoTabelaForm() {
    const { watch } = useFormContext()
    const isSemanal = watch('tipo') === 'SEMANAL'

    return (
        <>
            <Grid item xs={12} sx={{ mb: 2 }}>
                <Divider>Tipo de tabela</Divider>
            </Grid>
            <Grid item xs={12} sx={{ mb: 3 }}>
                <CardRadioForm
                    spacing={3}
                    name="tipo"
                    options={[
                        {
                            value: 'DIARIA',
                            titulo: 'Carga diária',
                            descricao:
                                'Horários definidos por dia da semana. Extras e faltas são apurados dia a dia.',
                        },
                        {
                            value: 'SEMANAL',
                            titulo: 'Carga semanal',
                            descricao:
                                'O horário de cada registro não importa: o funcionário só precisa cumprir o total de horas da semana.',
                        },
                    ]}
                />
            </Grid>
            {isSemanal && (
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Divider>Carga semanal</Divider>
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="totSem"
                            label="Total de horas semanais"
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda className="-mb-4">
                                        Total de horas que o funcionário deve
                                        cumprir na semana (ex.: 44:00). O
                                        sistema apura extra/falta no fim da
                                        semana, proporcional aos dias úteis.
                                    </IconeAjuda>
                                ),
                            }}
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="toleranciaSemana"
                            label="Tolerância semanal"
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda className="-mb-4">
                                        Diferença semanal dentro da tolerância
                                        não gera extra nem falta. Ex.: 00:10 em
                                        44:00 → de 43:50 a 44:10 a semana fecha
                                        zerada.
                                    </IconeAjuda>
                                ),
                            }}
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="limiteDiario"
                            label="Limite diário"
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda className="-mb-4">
                                        Horas trabalhadas acima deste limite num
                                        único dia viram extra imediatamente e
                                        saem do total da semana. Deixe vazio
                                        para não limitar.
                                    </IconeAjuda>
                                ),
                            }}
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="intervaloDesconto"
                            label="Descontar intervalo de"
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <IconeAjuda className="-mb-4">
                                        Intervalo pré-assinalado: descontado do
                                        dia quando o funcionário registra só
                                        entrada e saída. Preencha junto com o
                                        campo ao lado para ativar.
                                    </IconeAjuda>
                                ),
                            }}
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="intervaloAposHoras"
                            label="Quando o dia exceder"
                            placeholder="HH:mm"
                            options={{
                                blocks: [2, 2],
                                delimiters: [':'],
                                numericOnly: true,
                            }}
                            InputLabelProps={{ shrink: true }}
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
            )}
        </>
    )
}
